import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import { AddTagsModal } from '../../../../components/modals/add-tags-modal';
import { useModal } from '../../../../hooks/use-modal';

import messages from './messages';
import style from './tags.module.less';

export const BulkFulfillmentPlanTagDropdownBodyEmpty = () => {
  const { isOpen, close, open } = useModal();

  return (
    <>
      <div className={style['no-tags-indicator']}>
        <Text textType={TextType.Paragraph} value={messages.emptyTagList} />
        <Button className={style['fulfillment-plan-no-tags-action']} onClick={open} theme='primary'>
          <FormattedMessage {...messages.addTags} />
        </Button>
      </div>
      {isOpen && <AddTagsModal onClose={close} />}
    </>
  );
};
